import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InicioComponent } from './inicio/inicio.component';
import { Routes, RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../../core/material/material.module';
import { WebComponentModule } from '../web-component/web-component.module';


export const routes: Routes = [
  {
    path: 'inicio', component: InicioComponent
  },
]


@NgModule({
  declarations: [InicioComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forChild(routes),
    MaterialModule,
    WebComponentModule,
  ],
  exports:[
    RouterModule
  ],
  entryComponents:[InicioComponent]
})

export class HomeModule { 
}
